import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'replaceCharacter',
  standalone: true
})
export class ReplaceCharacterPipe implements PipeTransform {
  transform(value: string, args: {searchChar: string, replaceChar: string}): string {
    const {searchChar} = args;
    // Handle null/undefined input
    if (!value) {
      return '';
    }

    // Handle null/undefined search character
    if (!searchChar) {
      return value;
    }

    // Handle null/undefined replace character
    if (!args.replaceChar) {
       args.replaceChar = '';
    }

    // Convert to string to handle non-string inputs
    const stringValue = String(value);
    const replaceChar = args.replaceChar || '';
    
    // Handle empty string
    if (stringValue.length === 0) {
      return stringValue;
    }

    // Handle single character search
    if (searchChar.length === 1) {
      return stringValue.split(searchChar).join(replaceChar);
    }

    // If search character is longer than 1, treat it as a literal string to replace
    return stringValue.replace(new RegExp(searchChar, 'g'), replaceChar);
  }
} 